import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletMainTableRow = _resolveComponent("WalletMainTableRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('columns'))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedColumns, (column) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(_ctx.b('column', { action: column.id >= 2 })),
          key: column.id
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('column-label'))
          }, _toDisplayString(_ctx.$t(column.label)), 3),
          (column.sortable !== false)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(_ctx.b('column-sort')),
                onClick: ($event: any) => (_ctx.handleSort(column))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.b('column-icon')),
                  innerHTML: _ctx.displayedSvg.sort
                }, null, 10, _hoisted_2)
              ], 10, _hoisted_1))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2),
    (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(_ctx.b('rows')),
      key: 
        _ctx.filterKey +
        ':' +
        _ctx.displayedList.map((item) => item.type + ':' + item.id).join(',')
      
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedList, (item, index) => {
        return (_openBlock(), _createBlock(_component_WalletMainTableRow, {
          class: _normalizeClass([_ctx.b('row'), 'fade-swap']),
          style: _normalizeStyle({ animationDelay: `${index * 55}ms` }),
          key: item.id,
          row: item
        }, null, 8, ["class", "style", "row"]))
      }), 128))
    ], 2))
  ], 2))
}